import { BAOCustomElement } from '@bao/custom-element'

class ButtonText extends BAOCustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.splitCharacters()
  }

  splitCharacters () {
    // To animate in order
    let delayCounter = 0
    const characterDelayOffset = 0.01

    const buttonText = this.textContent || this.innerText || this.innerHTML

    if (!buttonText) return

    const characterArray = Array.from(buttonText)
    let buttonContent = ''

    characterArray.forEach((character) => {
      delayCounter = +(delayCounter + characterDelayOffset).toFixed(2)

      if (character === ' ') {
        buttonContent += ' '
      } else {
        buttonContent += `<span class="btn-Button_Character" style="--Character_Delay: ${delayCounter}s;" data-character="${character}" aria-hidden="true">${character}</span>`
      }
    })

    this.innerHTML = buttonContent
    if (!this.parentElement.hasAttribute('aria-label')) {
      this.parentElement.setAttribute('aria-label', buttonText)
    }
    this.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('button-text')) {
  customElements.define('button-text', ButtonText)
}
